module.exports = __webpack_public_path__ + "static/media/recurring_pending.f0c80ae0.svg";